<template>
  <div class="about">
    <div class="about-row container" data-aos="flip-down" :data-aos-duration="1500">
      <div class="about-banner">
        <el-carousel :interval="4000" type="card" height="200px">
          <el-carousel-item v-for="item in bannerList" :key="item.id">
            <div class="medium">
              <!--              <b>{{ item }}</b>-->
              <el-image :src="item.image_url"></el-image>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="about-text">
        <h1>关于我们</h1>
        <p>恩莱吉能源科技分别于2011年成立广州市恩莱吉能源科技有限
          公司和2013年成立深圳市恩莱吉能源科技有限公司。恩莱吉能源
          科技致力于绿色能源的开发和水电站高端控制设备、设计应用软件
          的研发，以增效扩容、节能环保为主发展方向，研究绿色水轮机、
          高油压调桨、机组节能等新技术的运用，并提供水利水电工程投资
          咨询、勘测设计、工程总承包等专业服务。&nbsp;&nbsp;&nbsp;
          <router-link to="/about"><i>查看更多 ></i></router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      bannerList: [],
    }
  },
  methods: {
    async getContactList() {
      let results = await this.$api.reqAboutBannerList()

      if (results.status === 200) {
        this.bannerList = results.results
      } else {
        this.$message({showClose: true, message: "轮播图请求失败！", type: "error"})
      }
    }
  },

  mounted() {
    this.getContactList()
  }
}
</script>

<style scoped lang="less">
.about {
  width: 100%;
  height: 470px;
  background-color: #14449B;

  .about-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;

    & > div {
      height: 263px;
    }

    .about-text {
      width: 450px;
      color: white;

      h1 {
        font-size: 30px;
        line-height: 60px;
      }

      p {
        font-size: 14px;
        line-height: 30px;
      }

      a {
        font-size: 14px;
        color: white;
        text-decoration: underline;

        &:hover {
          color: #3E88F8;
        }
      }
    }

    .about-banner {
      width: 700px;

      .el-carousel__item {
        color: #475669;
        opacity: 0.5;
        font-size: 60px;
        line-height: 250px;
        text-align: center;
        margin: 0;

        /deep/ .el-image__inner {
          height: 250px;
        }
      }

      .is-active {
        opacity: 1;
      }



      .el-carousel__item:nth-child(2n) {
        background-color: white;
      }

      .el-carousel__item:nth-child(2n+1) {
        background-color: white;
      }

      /deep/ .el-carousel__container {
        height: 245px !important;
      }
    }
  }
}
</style>